import {
  ChangeEvent,
  FunctionComponent,
  SyntheticEvent,
  useEffect,
  useState,
} from "react";
import { useNavigate, useLocation } from "react-router";
// Context

// Components
import NavBarComponent from "./../NavBar.Component";

import "./styles.scss";
import AuthAndSearch from "./AuthAndSearch";
import classNames from "classnames";
import AdminSection from "./AdminSection";
import { useAuth } from "../../../utils/hooks/useIsAuth";

type Props = {};

const NavBarDesktop: FunctionComponent<Props> = ({}) => {
  const [formData, setFormData] = useState({ product: "" });
  const { isAuth } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = location.pathname.includes("/admin");

  useEffect(() => {
    setFormData({ product: "" });
  }, [location.pathname]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSearch = (e: SyntheticEvent) => {
    e.preventDefault();
    navigate(`/search/${formData.product}`);
  };

  return (
    <>
      {location.pathname.includes("catalog") ? null : (
        <section
          className={classNames("nav_container", {
            "nav_container--admin": isAdmin,
          })}
          id="navBar"
        >
          <NavBarComponent />
          {isAdmin ? (
            <AdminSection />
          ) : (
            <AuthAndSearch
              handleChange={handleChange}
              isAuth={isAuth}
              handleSearch={handleSearch}
              searchValue={formData.product}
            />
          )}
        </section>
      )}
    </>
  );
};

export default NavBarDesktop;
